import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import clsx from 'clsx';
import styles from './styles.module.scss';
import { useRef } from 'react';

type Props = BaseButtonProps & {
    isSelected?: boolean;
    icon?: React.ReactNode;
    children?: React.ReactNode;
};

export const ViewStoreButton = ({ isSelected, icon, children, onClick, ...props }: Props) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleClickButton = (event: React.MouseEvent<HTMLButtonElement>) => {
        const target = event.currentTarget;
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        target.classList.add('button-dark__active');
        timeoutRef.current = setTimeout(() => {
            target.classList.remove('button-dark__active');
            onClick?.(event);
        }, 600);
    };

    return (
        <BaseButton
            {...props}
            onClick={handleClickButton}
            className={clsx('button-dark', styles['view-store-button'], {
                [styles['view-store-button--selected']]: isSelected,
            })}
        >
            <span className={styles['view-store-button__icon']}>{icon}</span>
            <span className={styles['view-store-button__text']}>{children}</span>
        </BaseButton>
    );
};
